import { BaseBritishColumbiaObstetricalFileSubSection, BaseBritishColumbiaObstetricalFileSubSectionProps } from "@/Patient/Components/MedicalNote/Obstetric/Form/BritishColumbia/Subcomponent/BaseBritishColumbiaObstetricalFileSubSection";

class BritishColumbiaObstetricalFileSection8 extends BaseBritishColumbiaObstetricalFileSubSection<BaseBritishColumbiaObstetricalFileSubSectionProps, never> {
    public render(): JSX.Element {
        const section8 = this.props.form.Section8;

        return (
            <div className="section">
                <div className="row row-form">
                    {this.renderHeader(
                        "LifestyleSocialConcerns",
                        8
                    )}
                    <div className="col-md-12">
                        {this.renderNoYesTitleSection5To9()}
                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.DietNutrition,
                        id: "Lifestyle_DietNutrition",
                        label: "ObstetricalFile_DietNutritionLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.DietNutrition.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.DietNutrition.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_DietNutritionDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.Exercise,
                        id: "Lifestyle_Exercise",
                        label: "ExerciseLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.Exercise.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.Exercise.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_ExerciseDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.Financial,
                        id: "Lifestyle_Financial",
                        label: "FinancialLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.Financial.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.Financial.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_FinancialDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.HousingFoodSecurity,
                        id: "Lifestyle_HousingFoodSecurity",
                        label: "ObstetricalFile_HousingFoodSecurityLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.HousingFoodSecurity.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.HousingFoodSecurity.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_HousingFoodSecurityDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.Transportation,
                        id: "Lifestyle_Transportation",
                        label: "TransportationLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.Transportation.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.Transportation.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_TransportationDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.Safety,
                        id: "Lifestyle_Safety",
                        label: "SafetyLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.Safety.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.Safety.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_SafetyDescription.MaxChars
                    })}
                    <div className="col-md-12 flex-display padding-xs-top">
                        {this.controlRenderer.renderInlineRadio({
                            value: section8.HasGenderBasedViolence,
                            items: this.getFalseTrueRadioOptionsWithoutLabel(),
                            onChange: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.HasGenderBasedViolence = value),
                            id: "LifeStyle_GenderBasedViolenceLabel",
                            className: "radios-one-label",
                            optionSpacing: "15px"
                        })}
                        <label className="margin-none margin-xs-left">{this.getString("GenderBasedViolenceLabel")}</label>
                    </div>
                    <div className="col-md-12 flex-display padding-xs-top padding-xs-bottom">
                        <div className="flex-display flex-col-gap-md" style={{ marginLeft: "55px" }}>
                            {this.controlRenderer.renderCheckbox(
                                "PartnerLabel",
                                section8.HasGenderBasedViolenceFromThePartner,
                                value => this.props.mutateModelStateWithFormUpdate(s => {
                                    s.Section8.HasGenderBasedViolenceFromThePartner = value;
                                    s.Section8.HasGenderBasedViolence ??= true;
                                })
                            )}
                            {this.controlRenderer.renderCheckbox(
                                "NonPartnerLabel",
                                section8.HasGenderBasedViolenceFromNonPartner,
                                value => this.props.mutateModelStateWithFormUpdate(s => {
                                    s.Section8.HasGenderBasedViolenceFromNonPartner = value;
                                    s.Section8.HasGenderBasedViolence ??= true;
                                })
                            )}
                        </div>
                    </div>
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.RelationshipsSupport,
                        id: "Lifestyle_RelationshipsSupport",
                        label: "RelationshipsSupport",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.RelationshipsSupport.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.RelationshipsSupport.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_RelationshipsSupportDescription.MaxChars
                    })}
                    {this.renderRadioButtonsWithTextBox({
                        value: section8.Other,
                        id: "Lifestyle_Other",
                        label: "OtherLabel",
                        onChangeBoolean: value => this.props.mutateModelStateWithFormUpdate(s => s.Section8.Other.Value = value),
                        onChangeDescription: value => this.props.mutateModelState(s => s.Section8.Other.setDescription(value)),
                        maxLength: this.page1FieldLimits.LifestyleSocialConcerns_OtherDescription.MaxChars
                    })}
                    {this.renderAllEmptyFieldAsNoLink(
                        () => this.props.mutateModelStateWithFormUpdate(s => s.Section8.setEmptyFieldsAsNo())
                    )}
                </div>
            </div>
        );
    }
}

export { BritishColumbiaObstetricalFileSection8 };
